import React, { useState, useEffect } from "react";
import { Formik } from "formik";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import { useHistory } from "react-router-dom";
import Layout from "../../components/Layout";
import FormFooter from "../../components/FormFooter";
import FormHeader from "../../components/FormHeader";
import Stepper from "../../components/Stepper";
import FormProperty from "../../components/FormProperty";
import {
  updateProperty,
  addProperty,
  getProperty,
} from "../../services/properties";
import { PROPERTY_VALIDATION_SCHEMA as validationSchema } from "../../constants/validation";
import { PROPERTY_INITIAL_VALUES } from "../../constants/initialValues";

function AppAddProperty(props) {
  const history = useHistory();
  const id = props.match.params?.id;
  const [initialValues, setInitialValues] = useState(PROPERTY_INITIAL_VALUES);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (id) {
      setIsLoading(true);
      getProperty(id).then((data) => {
        setInitialValues(data);
        setIsLoading(false);
      });
    }
  }, [id]);

  const onSubmit = (values) => {
    setIsLoading(true);
    if (id) {
      updateProperty(id, values).then((data) => {
        history.push(`/add-property/${data.id}/lease`);
      });
    } else {
      addProperty(values).then((data) => {
        history.push(`/add-property/${data.id}/lease`);
      });
    }
  };

  return (
    <Layout isLoading={isLoading}>
      <Stepper currentStepIndex={0} id={id} />
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {({ handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <Box sx={{ gridArea: "main" }}>
              <Paper sx={{ padding: "2rem", marginBottom: "1rem" }}>
                <FormHeader
                  title="Property"
                  description={[
                    "Please provide all details of of the apartment you intend to list, this information will be viewable to all prospective tenants.  By filling this out you are also complying with HUD and The Fair Housing Act ",
                    <a
                      href="https://www.hud.gov/program_offices/fair_housing_equal_opp/fair_housing_act_overview#_The_Fair_Housing"
                      target="_blank"
                    >
                      Housing Discrimination Under the Fair Housing Act
                    </a>,
                    ".",
                  ]}
                />
                <Grid container spacing={1}>
                  <FormProperty />
                </Grid>
              </Paper>
              <FormFooter />
            </Box>
          </form>
        )}
      </Formik>
    </Layout>
  );
}

export default AppAddProperty;
